import request from '@/utils/request'

export function search (data) {
  return request({
    url: '/commonModule/search/data',
    method: 'get',
    params: data
  })
}
